import cn from 'classnames';
import React, { useEffect, useReducer } from 'react';

// REDUX
import { getAccount, getDeviceInfo, getGlobalStyles } from '@Managers/Redux/AppState/AppState';
import { useAppSelector } from '@Managers/Redux/Hooks';

// TYPES
import { DOM_ID } from '@UILayer/UILayer.types';

// CSS
import styles from '@UILayer/UILayer.scss';

// BUTTONS

// IMAGES
import { Button } from '@UILayer/Inputs/Button';
import { useTranslation } from 'react-i18next';
import minIcon from './icon_minimize.svg';

const FreeSpinBar: React.FC<{}> = ({}) => {
    const [state, setState] = useReducer(
        (state: { open: boolean; active: boolean; data: { balance: number; text: string } }, newState: any) => ({ ...state, ...newState }),
        {
            open: true,
            active: false,
            data: { balance: 0, text: '' }
        }
    );
    const gameStoreAccount = useAppSelector(getAccount);
    const globalStyles = useAppSelector(getGlobalStyles);
    const { t } = useTranslation();
    const device = useAppSelector(getDeviceInfo);

    const containerClasses = cn(styles.freeSpinBar_container, globalStyles.wcaMode, globalStyles.orientation, {
        [styles.open]: state.open ? true : false
    });

    const toggleClasses = cn(styles.freeSpinBar_toggle_button, globalStyles.wcaMode, {
        [styles.open]: state.open ? true : false
    });

    function panelAction(visible: boolean) {
        setState({ open: visible });
    }

    useEffect(() => {
        if (gameStoreAccount.bonuses.freeSpins && !gameStoreAccount.bonuses.freeSpins.suspend) {
            const { balance } = gameStoreAccount.bonuses.freeSpins;
            const langText = t('FREE_SPINS_BAR_MESSAGE');
            setState({
                active: true,
                data: {
                    balance: balance,
                    text: langText.replace('%value', JSON.stringify(balance))
                }
            });
        } else {
            setState({ active: false });
        }
    }, [gameStoreAccount.bonuses.freeSpins]);

    return (
        <>
            {state.active && (
                <>
                    {device.windowOrientationHorizontal ? (
                        <>
                            {state.active && (
                                <>
                                    <div className={containerClasses}>
                                        <div className={styles.freeSpinBar_content}>
                                            <div className={styles.freeSpinBar_inner}>
                                                <div className={styles.freeSpinBar_message} tabIndex={0} aria-description={`${state.data.text} `}>
                                                    {state.data.text}
                                                </div>
                                                <div className={styles.freeSpinBar_button}>
                                                    <Button
                                                        id={DOM_ID.BUTTON_FREE_SPIN_TOGGLE}
                                                        description={t('WCA_FREE_SPINS_BAR_BUTTON_HIDE')}
                                                        onChange={() => panelAction(false)}
                                                    >
                                                        <img src={minIcon} alt={`${t('WCA_FREE_SPINS_BAR_BUTTON_HIDE')} image`} />
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Button
                                        id={DOM_ID.BUTTON_FREE_SPIN_TOGGLE}
                                        description={t('WCA_FREE_SPINS_BAR_BUTTON_SHOW')}
                                        onChange={() => panelAction(true)}
                                        className={cn(toggleClasses, globalStyles.wcaMode, globalStyles.orientation)}
                                    >
                                        {t('FREE_SPINS_BAR_BUTTON')}
                                    </Button>
                                </>
                            )}
                        </>
                    ) : (
                        <>
                            <div className={containerClasses}>
                                <div className={styles.freeSpinBar_content}>
                                    <div className={styles.freeSpinBar_inner}>
                                        <div className={styles.freeSpinBar_message} tabIndex={0} aria-description={`${state.data.text} `}>
                                            {state.data.text}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default FreeSpinBar;
